<template>
  <div class="progress">
    <div class="progress__progress">
      <div>
        <CourseProgressIcon
          class="progress__progress-icon"
        ></CourseProgressIcon>
      </div>
      <p class="progress__progress-title">Course Progress</p>
    </div>
    <div class="progress__bar-wrapper">
      <ProgressBar :value="progressPercentage.toString()"></ProgressBar>
    </div>
    <div class="progress__button-wrapper">
      <button
        class="btn btn--secondary"
        @click="$emit('resume')"
        :style="progressPercentage === 100 ? 'pointer-events: none' : ''"
      >
        <PlayIcon />
        {{ isCompleteText }}
      </button>
    </div>
  </div>
</template>

<script>
import CourseProgressIcon from '@/assets/icons/progress/course-progress-icon.svg'
import ProgressBar from '@/components/properties/ProgressBar.vue'
import PlayIcon from '@/assets/icons/fill/play.svg'

export default {
  name: 'CourseProgress',
  components: {
    CourseProgressIcon: { ...CourseProgressIcon, name: 'CourseProgressIcon' },
    ProgressBar,
    PlayIcon: { ...PlayIcon, name: 'PlayIcon' },
  },
  props: {
    progressPercentage: {
      required: true,
      type: Number,
    },
  },
  computed: {
    isCompleteText() {
      const { progressPercentage } = this
      switch (progressPercentage) {
        case 0:
          return 'Begin'
        case progressPercentage > 0 && progressPercentage < 100:
          return 'Resume'
        case 100:
          return 'Complete'
        default:
          return 'Resume'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  align-items: center;
  background-color: var(--light-gray);
  border-radius: 75px;
  margin: 0 auto;
  margin-bottom: 50px;
  padding: 25px;
  @include tablet {
    padding: 25px 50px;
  }
  &__progress {
    align-items: center;
    justify-content: center;
    display: none;
    @include mobile {
      display: flex;
    }
  }
  &__progress-icon {
    fill: var(--green);
    height: 58px;
    margin-right: 27px;
  }
  &__progress-title {
    color: var(--white);
    font-size: 22px;
    margin: 0 30px 0 0;
    width: 100%;
    font-family: var(--font-bold);
    line-height: 1.5rem;
    letter-spacing: -0.44px;
  }
  &__bar-wrapper {
    width: 100%;
    margin-right: 45px;
  }
  .disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
